const React = require("react");
const T = React.PropTypes;
const _ = require("lodash");
const UUID = require("node-uuid");

const FileSelectionActionCreators = require("../actionCreators/FileSelectionActionCreators.js");
const File = require("../types/File.js");

const SelectedFileProgress = require("./SelectedFileProgress.jsx");
const TitledMessage = require("./TitledMessage.jsx");

const styles = {
    Outer: {
        padding: "10px 0 350px",
        overflow: "auto",
        margin: "auto",
        marginTop: 20,
        width: 720
    },
    DragOver: {
        backgroundColor: "rgba(200, 220, 200, .4)",
        border: "1px dashed"
    }
};

const SelectedFileProgressList = React.createClass({
    propTypes: {
        style: T.object,
        Files: T.arrayOf(File.Type)
    },
    getDefaultProps(){
        return {
            style: {}
        };
    },
    getInitialState() {
        return {
            IsDraggedOver: false
        };
    },
    render() {
        const style = Object.assign({}, styles.Outer, this.props.style);

        let children = null;

        if ((this.props.Files || []).length) {
            children = this.GetSelectedFiles();
        }
        else {
            children = (<TitledMessage Title="Something is wrong.  Please contact support."
                                       Subtitle='(We should never be in "Progress" mode without any files selected.)' />);
        }
        
        return (<div style={style}>
            {children}
        </div>);
    },
    GetSelectedFiles() {
        const fileStyle = {
            margin: 20
        };

        const result = this.props.Files.map((f) => {
            return (<SelectedFileProgress key={f.UID} File={f} style={fileStyle } />);
        });

        return result;
    }
});

module.exports = SelectedFileProgressList;


// WEBPACK FOOTER //
// ./src/components/SelectedFileProgressList.jsx